import { useEffect } from 'react';
import { useStore } from '../store/useStore';
import { useDocControllerContext } from '../hooks/DocControllerContext';
import { useT } from '../i18n/useT';
import { Icon } from './Icon';

/** Toast shown after a soft-delete, offering to restore the document. */
export function UndoToast() {
  const t = useT();
  const undo = useStore((s) => s.undoDelete);
  const setUndo = useStore((s) => s.setUndoDelete);
  const controller = useDocControllerContext();

  useEffect(() => {
    if (!undo) return;
    const timer = window.setTimeout(() => setUndo(null), 8000);
    return () => window.clearTimeout(timer);
  }, [undo, setUndo]);

  if (!undo) return null;
  return (
    <div className="mb-toast" role="status">
      <span>{t('undo.deleted', { title: undo.title })}</span>
      <button className="mb-btn" onClick={() => void controller.restore(undo.docId)}>
        {t('undo.undo')}
      </button>
      <button
        className="mb-toast-close"
        aria-label={t('pwa.dismiss')}
        onClick={() => setUndo(null)}
      >
        <Icon name="x" size={13} />
      </button>
    </div>
  );
}
